
import { Component, Prop, Vue } from 'vue-property-decorator'

import { DotationOrderForm } from '../types/dotationOrderForm'

@Component({ name: 'StepDistributionMode' })
export default class extends Vue {
  @Prop({ required: true }) form!: DotationOrderForm
}
